module.exports = __webpack_public_path__ + "img/icon-simple.98d10659.svg";